// "Your RAG Has 3 Steps. Mine Has 11" — the 11-stage RAG pipeline short.
// Cold Compute / Neon kit. ~145s @ 30fps. Grounded in EAKC-MVP src/lib/rag/* + migs 009/033/034.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  3 steps vs 11 stages
  naive: { start: 150, duration: 420 }, //      0:05–0:19  the 3-step tutorial RAG
  broke: { start: 570, duration: 540 }, //      0:19–0:37  5 things that broke in prod
  pipeline: { start: 1110, duration: 600 }, //  0:37–0:57  the 11-stage map
  understand: { start: 1710, duration: 420 }, //0:57–1:11  stages 1–4: understand the query
  search: { start: 2130, duration: 660 }, //    1:11–1:33  stage 7 hybrid + the silent BM25 bug
  guard: { start: 2790, duration: 420 }, //     1:33–1:47  stages 8–9 access + rerank
  payoff: { start: 3210, duration: 540 }, //    1:47–1:65  ~75% → peak 90%
  outro: { start: 3750, duration: 330 }, //     1:65–2:16
} as const;

export const TOTAL_DURATION = 4080; // 136s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
